export const environment = {
  production: true,
  apiUrl: window.location.origin,
  clientId: '6d29b093-2df2-4735-aedd-80cda294830e',
  authority: 'https://login.microsoftonline.com/',
  eyTenant: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
  eyExtTenant: '99050bca-65fe-4f6d-8478-388cd894a57f',
  redirectUrl: window.location.origin + '/',
};
